import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getBlooddonation, editBlooddonation } from "../../store/actions/blooddonations_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import { initialValues, inputFields } from "../../shared/enums/blooddonations_enum";

const EditBlooddonation = ({ editBlooddonation, getBlooddonation, match, blooddonation: { loading, blooddonation } }) => {
    let history = useHistory();
    useEffect(() => {
        getBlooddonation(match.params.id);
    }, [match]);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [gallery, setGallery] = useState(null);
    const submitBlooddonation = async (values) => {
        if (featuredImage || gallery) {
            const images = await upload(featuredImage, gallery);
            if (images) {
                if (images.featured_image) {
                    values.featured_image = images.featured_image;
                }
                if (images.gallery_images) {
                    values.gallery = images.gallery_images;
                }
            }
        }
        await editBlooddonation(blooddonation.id, values);
        history.push(`/blooddonations/${blooddonation.id}/view`);
    };

    return (
        <div className="pace-done">
            <div>
                <Header />
                <BreadCrumb
                    title="Edit Blooddonation"
                    mainLinkTitle="Blooddonations"
                    mainLinkUrl="/blooddonations"
                    activeLink="Edit"
                />
            </div>
            <div className="container-fluid">
                <div className="col-lg-12">
                    <div className="card">
                        {!loading ? (
                            blooddonation && (
                                <div>
                                    <div className="card-header">
                                        <div>
                                            <h4 className="card-title">
                                                {blooddonation.title} - <span>Edit</span>{" "}
                                            </h4>
                                            <p className="card-title-desc">
                                                <Link to="/blooddonations" className="btn btn-soft-light">
                                                    <i className="fa fa-angle-left"></i> Blooddonations
                                                </Link>
                                                <Link
                                                    to={`/blooddonations/${blooddonation.id}/view`}
                                                    className="btn btn-soft-light"
                                                >
                                                    <i className="fa fa-eye"></i>
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                    <AddForm
                                        data={blooddonation}
                                        edit={true}
                                        featuredImage={featuredImage}
                                        gallery={gallery}
                                        setFeaturedImage={setFeaturedImage}
                                        setGallery={setGallery}
                                        submitForm={submitBlooddonation}
                                        inputFields={inputFields}
                                        initialValues={initialValues}
                                    />
                                </div>
                            )
                        ) : (
                            <div className="text-center">
                                <Spinner />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    alert: state.alert,
    blooddonation: state.blooddonation,
});

const mapDispatchToProps = { editBlooddonation, getBlooddonation };

export default connect(mapStateToProps, mapDispatchToProps)(EditBlooddonation);
